import { useEffect, useState } from 'react'
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  TextField
} from '@mui/material'
import { isAnyBlank } from '../../utils/string'
import FechaSelector from '../../components/form/FechaSelector/FechaSelector'
import HoraSelector from '../../components/form/HoraSelector/HoraSelector'
import FormaContactoSelector from '../../components/form/FormaContactoSelector/FormaContactoSelector'
import { dateToString, dateToTimeString } from '../../utils/date'
import css from './ModalContactoLeadCualificado.module.css'

const ModalContactoLeadCualificado = ({
  open,
  disabled,
  onSubmit,
  onClose
}) => {
  const [cualificado, setCualificado] = useState({
    fecha: null,
    hora: null,
    contactado: true,
    fecha_incorporacion: null,
    presupuesto: '',
    observaciones: '',
    forma_contacto: ''
  })

  useEffect(() => {
    setCualificado({
      fecha: null,
      hora: null,
      contactado: true,
      fecha_incorporacion: null,
      presupuesto: '',
      observaciones: ''
    })
  }, [open])

  const isSubmitDisabled = isAnyBlank(
    cualificado.fecha,
    cualificado.hora,
    cualificado.presupuesto,
    cualificado.forma_contacto
  )

  const handleSubmit = () => {
    onSubmit({
      leadStatus: 'LEAD_CUALIFICADO',
      fechaLeadCualificado: dateToString(cualificado.fecha),
      contactado: cualificado.contactado,
      fechaIncorporacionLeadCualificado: dateToString(
        cualificado.fecha_incorporacion
      ),
      horaLeadCualificado: dateToTimeString(cualificado.hora),
      presupuestoLeadCualificado: cualificado.presupuesto,
      formaContactoLeadCualificado: cualificado.forma_contacto,
      observaciones: cualificado.observaciones
    })
  }

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <DialogTitle>Datos lead cualificado</DialogTitle>
      <DialogContent className={css.main}>
        <DialogContentText className={css.intro}>
          Rellena los datos asociados al presupuesto ofrecido al lead
        </DialogContentText>
        <FechaSelector
          className={css.input}
          label='Fecha incorporación estimada'
          value={cualificado.fecha_incorporacion}
          disablePast
          onChange={fecha_incorporacion =>
            setCualificado({ ...cualificado, fecha_incorporacion })
          }
        />
        <FechaSelector
          className={css.input}
          label='Fecha próximo contacto'
          value={cualificado.fecha}
          disablePast
          onChange={fecha => setCualificado({ ...cualificado, fecha })}
        />
        <HoraSelector
          className={css.input}
          label='Hora próximo contacto'
          value={cualificado.hora}
          onChange={hora => setCualificado({ ...cualificado, hora })}
        />
        <FormaContactoSelector
          className={css.input}
          label='Forma de contacto'
          value={cualificado.forma_contacto}
          onChange={e =>
            setCualificado({ ...cualificado, forma_contacto: e.target.value })
          }
        />
        <TextField
          className={css.input}
          label='Presupuesto ofrecido'
          multiline
          value={cualificado.presupuesto}
          onChange={e =>
            setCualificado({ ...cualificado, presupuesto: e.target.value })
          }
          variant='standard'
        />
        <TextField
          className={css.input}
          label='Observaciones'
          multiline
          value={cualificado.observaciones}
          onChange={e =>
            setCualificado({ ...cualificado, observaciones: e.target.value })
          }
          variant='standard'
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={!cualificado.contactado}
              onChange={e =>
                setCualificado({
                  ...cualificado,
                  contactado: !e.target.checked
                })
              }
            />
          }
          label='No se ha podido contactar con el lead'
        />
      </DialogContent>
      <DialogActions>
        <Button color='error' disabled={disabled} onClick={onClose}>
          Cancelar
        </Button>
        <Button
          disabled={isSubmitDisabled || disabled}
          color='primary'
          onClick={handleSubmit}
        >
          Anotar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalContactoLeadCualificado
